import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-8" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x-0 md:divide-x divide-legal-700" data-id="element-257">
          <div className="flex flex-col items-center justify-center" data-id="element-258">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-259">+500</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-260">
              Abogados confían
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-261">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-262">100%</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-263">
              Modelos listos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-264">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-265">2026</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-266">
              Jurisprudencia actual
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-267">
            <span className="text-3xl mb-1" data-id="element-268">🇦🇷</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-269">
              Todo el país
            </span>
          </div>
        </div>
      </div>
    </div>;
};